<template>
  <div class="box" ref="container">
    <div class="searchBox">
      <div class="searchTitle">查职业</div>
      <div class="search">
        <span class="header-search-input___gKtlk">
          <input v-model="obj.KeyWord" placeholder="搜索你感兴趣的专业" @keyup.enter="serve()" />
          <span class="prefix">
            <i class="el-icon-search"></i>
          </span>
        </span>
      </div>
      <div class="searchTag">
        <div class="tag" v-for="(item, index) in rcList" :key="index" @click="rcClick(item.name)">{{ item.name }}</div>
      </div>
    </div>
    <div class="content">
      <div class="leftContent">
        <div class="list">
          <div class="ListItemBox" v-for="(it, idx) in list" :key="idx">
            <div class="ListItemTitle">
              <div class="Zy">{{ it.rootName }}</div>
              <div class="Js">{{ it.itemDtos.length }}个职业类</div>
            </div>
            <div class="ListItemList">
              <div class="ListItemItem">
                <div class="right">
                  <div class="Xl" v-for="(its, idxs) in it.itemDtos" :key="idxs" @click="goDetail(its.id)">{{ its.name
                    }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rightContent">
        <div class="banes">
          <div class="item" @click="goUrl('/Home/Assessment')">
            <img src="./images/11.png" alt="" />
          </div>
          <div class="item" @click="goUrl('/Home/ZhanJiaList')">
            <img src="./images/22.png" alt="" />
          </div>
        </div>
        <div class="articleCont_right_zhengce">
          <div class="title">热门职业</div>
          <div class="school-box">
            <div class="school-item" v-for="(it, index) in hottestJobs2026" :key="index">
              <div class="schoolName">
                <span class="name"> {{ index + 1 }}</span>
                <span class="type">{{ it.name }}</span>
              </div>
              <div class="Rd">招聘 {{ it.count }}万人</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetbaseProfessione } from "@/api/Occupation";
export default {
  name: "SearchUniversityIndex",
  components: {},
  data() {
    return {
      obj: {
        KeyWord: ''
      },
      rcList: [
        {
          name: '传媒文化类'
        },
        {
          name: '体育学'
        },
        {
          name: '保险类'
        },
        {
          name: '公务员类'
        },
        {
          name: '农业类'
        },
        {
          name: '化工环保类'
        },
        {
          name: '医疗类'
        },
        {
          name: '工程技术类'
        },
        {
          name: '建筑类'
        },
        {
          name: '教育类'
        },
        {
          name: '法律类'
        },
        {
          name: '生产制造类'
        },
      ],
      list: [],
      hottestJobs2026 : [
        { name: "智能体开发工程师", count: 8.5 },
        { name: "AI解决方案架构师", count: 7.2 },
        { name: "具身智能工程师", count: 6.8 },
        { name: "机器人算法工程师", count: 7.6 },
        { name: "芯片设计工程师", count: 5.4 },
        { name: "电子电路设计师", count: 6 },
        { name: "低空飞控系统工程师", count: 4.3 },
        { name: "无人机群飞行规划员", count: 3.9 },
        { name: "新能源汽车三电工程师", count: 8.8 },
        { name: "生物医药研发工程师", count: 6.5 }
      ]
    };
  },

  mounted() {
    this.getList()
  },

  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    rcClick(name) {
      this.obj.KeyWord = name
      this.getList()
    },
    serve() {
      this.getList()
    },
    goDetail(id) {
      console.log(id);
      const routeData = this.$router.resolve({
        path: "/Home/CareerDetails",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    async getList() {
      const res = await GetbaseProfessione({
        ...this.obj
      })
      this.list = res.data.result
      console.log(res.data.result);
    }
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
}

.box {
  margin: 0 auto;
  min-height: 100vh;
  background: #ffffff;
}

.searchBox {
  background-image: url("./images/bac.png");
  background-size: 100% 100%;
  height: 330px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .searchTitle {
    margin-top: 77px;
    font-weight: 600;
    font-size: 32px;
    margin-bottom: 20px;
  }

  .search {
    .header-search-input___gKtlk {
      position: relative;
      align-items: center;
      width: 658px;
      height: 46px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #a3cbff;
      font-size: 14px;
      padding: 4px 11px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1.5715;
      background-color: #fff;
      background-image: none;
      border: 1px solid #d9d9d9;
      transition: all 0.3s;
      display: inline-flex;

      .prefix {
        margin-top: 5px;
        margin-right: 5px;
      }

      .prefix>i {
        font-size: 18px;
      }
    }
  }

  .searchTag {
    margin-top: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 16px;
    width: 1280px;

    .tag {
      min-width: 10%;
      cursor: pointer;
      margin-bottom: 12px;
      text-align: left;
    }

    .tag:hover {
      color: #187cff;
    }
  }

  input {
    height: 50px;
    width: 100%;
    padding: 0;
    font-size: inherit;
    border: none;
    outline: none;
  }
}

.content {
  display: flex;
  width: 1280px;
  margin: 0 auto;
  margin-top: 20px;
}

.leftContent {
  flex: 1;
  min-width: 956px;
  margin-right: 16px;

  .tabs {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #187cff;

    .tabItem {
      cursor: pointer;
      width: 104px;
      height: 38px;
      color: #187cff;
      border-radius: 8px 8px 0px 0px;
      text-align: center;
      line-height: 38px;
      font-size: 16px;
    }

    .active {
      background: #187cff;
      color: #ffffff;
    }
  }

  .list {
    .ListItemBox {
      padding: 40px 0;
      border-bottom: 1px solid #eeeeee;

      .ListItemTitle {
        display: flex;
        align-items: center;
        margin-bottom: 32px;

        .Zy {
          font-weight: 600;
          font-size: 20px;
          margin-right: 16px;
        }

        .Js {
          font-size: 14px;
          color: #86909c;
        }
      }

      .ListItemList {
        margin-bottom: 42px;

        .ListItemItem {
          display: flex;
          align-items: top;

          .right {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            font-size: 16px;

            .Xl {
              cursor: pointer;
              width: 20%;
              margin-bottom: 16px;
            }

            .Xl:hover {
              color: #187cff;
            }
          }
        }
      }
    }
  }
}

.rightContent {
  width: 308px;
  overflow: hidden;
  float: left;

  .banes {
    width: 100%;

    .item {
      cursor: pointer;
      width: 308px;
      height: 154px;
      margin-bottom: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .articleCont_right_zhengce {
    width: 100%;
    background: linear-gradient(#d9ebfb 0%, #ffffff 20%);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #ddecff;
    box-sizing: border-box;
    padding: 24px 20px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      font-weight: 600;
      font-size: 20px;
      color: #187cff;

      .more {
        display: flex;
        align-items: center;
        padding: 4px;
        height: 33px;
        background: #cbdfff;
        border-radius: 6px 6px 6px 6px;

        .moTab {
          width: 40px;
          height: 25px;
          border-radius: 4px 4px 4px 4px;
          font-size: 12px;
          text-align: center;
          line-height: 25px;
          cursor: pointer;
        }

        .actives {
          background: #ffffff;
          color: #187cff;
          font-weight: bold;
        }
      }
    }

    .school-box {
      margin-top: 38px;

      div,
      .school-box .school-item {
        display: flex;
        align-items: center;
      }

      .school-item:hover .type {
        color: #187cff !important;
      }

      .school-item {
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .schoolName {
          font-size: 14px;
          display: flex;

          .type {
            margin-left: 10px;
          }
        }

        .Rd {
          font-size: 14px;
          color: #888;
        }
      }
    }

    .policy_title:hover {
      color: #187cff !important;
      cursor: pointer;
    }
  }
}

// ------loading样式---------
.loading_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  padding: 20px 0;

  .loading {
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border: 2px solid #ddd;
    border-radius: 50%;
    animation: rotate 1s linear infinite;
    margin-right: 10px;
  }

  .container {
    position: relative;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #fff;
  }
}

/*------loading动画---------*/
@keyframes rotate {
  from {
    transform-origin: center center;
    transform: rotate(0deg);
  }

  to {
    transform-origin: center center;
    transform: rotate(360deg);
  }
}
</style>
